import {Check} from "../../../../types/type-checking";
import {ILanguageService} from "../../../language/language.service.interface";

export type Gender = 'Male' | 'Female' | 1 | 2;
export type NullableGender = Gender | null;

export function genderToNumber(gender: NullableGender): NullableGender {
    if(Check.isNullOrUndefined(gender)) {
        return null;
    }

    switch (gender) {
        case "Male":
            return 1;
        case "Female":
            return 2;
        default:
            return gender;
    }
}

export function genderToString(gender: NullableGender | undefined): NullableGender {
    if(Check.isNullOrUndefined(gender)) {
        return null;
    }

    switch (gender) {
        case 1:
            return "Male";
        case 2:
            return "Female";
        default:
            return gender;
    }
}

export function translateGender(gender: NullableGender, language: ILanguageService): string {
    switch (gender) {
        case "Male":
        case 1:
            return language.translate('Male');
        case "Female":
        case 2:
            return language.translate('Female');
        default:
            return "";
    }
}